var _style, _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "23 23 90 90",
    style: {
      enableBackground: "new 0 0 113.73 113.73"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#DCDBDB;}\n\t.st1{fill:#140F41;}\n\t.st2{fill:#453192;}\n\t.st3{fill:#CD1F38;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M75.55,69.02L75.55,69.02c-4.67,0-8.49-3.82-8.49-8.49V48.64c0-4.67,3.82-8.49,8.49-8.49h0 c4.67,0,8.49,3.82,8.49,8.49v11.88C84.04,65.2,80.22,69.02,75.55,69.02z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75.72,48.86c-4.8,0-8.7-3.91-8.7-8.7s3.91-8.7,8.7-8.7c4.8,0,8.7,3.91,8.7,8.7S80.52,48.86,75.72,48.86z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 75.72,
    cy: 39.42,
    r: 6.96
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "73.36,32.47 73.36,35.94 75.72,37.78 75.72,31.91  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "78.08,32.47 78.08,35.94 75.72,37.78 75.72,31.91  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "72.12,66.8 69.24,63.21 69.27,49.14 70.26,46.22 71.2,46.54 70.24,49.38 70.24,62.85 72.9,66.18 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "79.07,66.8 78.29,66.18 80.95,62.85 80.95,49.38 79.99,46.54 80.93,46.22 81.95,49.3 81.95,63.21 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "73.06,67.44 71.96,67.44 71.41,66.49 71.96,65.54 73.06,65.54 73.61,66.49  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "79.23,67.44 78.13,67.44 77.59,66.49 78.13,65.54 79.23,65.54 79.78,66.49  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 70.63,
    y: 39.92,
    className: "st1",
    width: 3.57,
    height: 1.44
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 77.17,
    y: 39.92,
    className: "st1",
    width: 3.57,
    height: 1.44
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M37.85,68.84L37.85,68.84c-4.67,0-8.49-3.82-8.49-8.49V48.46c0-4.67,3.82-8.49,8.49-8.49h0 c4.67,0,8.49,3.82,8.49,8.49v11.88C46.34,65.02,42.52,68.84,37.85,68.84z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.02,48.68c-4.8,0-8.7-3.91-8.7-8.7s3.91-8.7,8.7-8.7s8.7,3.91,8.7,8.7S42.82,48.68,38.02,48.68z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 38.02,
    cy: 39.24,
    r: 6.96
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "35.66,32.28 35.66,35.76 38.02,37.59 38.02,31.73  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "40.38,32.28 40.38,35.76 38.02,37.59 38.02,31.73  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "34.42,66.62 31.54,63.02 31.57,48.95 32.56,46.03 33.51,46.35 32.54,49.2 32.54,62.67 35.2,66  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "41.37,66.62 40.59,66 43.25,62.67 43.25,49.2 42.29,46.35 43.24,46.03 44.25,49.12 44.25,63.02  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "35.36,67.26 34.26,67.26 33.71,66.31 34.26,65.36 35.36,65.36 35.91,66.31  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "41.53,67.26 40.44,67.26 39.89,66.31 40.44,65.36 41.53,65.36 42.08,66.31  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 32.93,
    y: 39.74,
    className: "st1",
    width: 3.57,
    height: 1.44
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 39.47,
    y: 39.74,
    className: "st1",
    width: 3.57,
    height: 1.44
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56.67,74.08c-6.19,0-11.22-4.8-11.22-10.7V49.79c0-5.9,5.04-10.71,11.22-10.71s11.22,4.8,11.22,10.71v13.59 C67.89,69.28,62.85,74.08,56.67,74.08z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M56.67,73.08L56.67,73.08c-5.34,0-9.7-4.37-9.7-9.7V49.79c0-5.34,4.37-9.7,9.7-9.7h0c5.34,0,9.7,4.37,9.7,9.7 v13.59C66.37,68.71,62,73.08,56.67,73.08z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56.85,50.04c-5.49,0-9.95-4.46-9.95-9.95s4.46-9.95,9.95-9.95s9.95,4.46,9.95,9.95S62.34,50.04,56.85,50.04z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 56.85,
    cy: 39.24,
    r: 7.95
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "54.16,31.29 54.16,35.27 56.85,37.36 56.85,30.66  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "59.55,31.29 59.55,35.27 56.85,37.36 56.85,30.66  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "52.8,70.5 49.52,66.41 49.55,50.37 50.68,47.04 51.63,47.36 50.52,50.62 50.52,66.06 53.58,69.88 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "60.64,70.5 59.86,69.88 62.91,66.06 62.91,50.62 61.81,47.36 62.75,47.04 63.91,50.53 63.91,66.41 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M53.77,71.21H52.6l-0.59-1.02l0.59-1.01h1.17l0.59,1.01L53.77,71.21z M53.18,70.21l0.03-0.02l-0.03-0.01 l-0.01,0.01L53.18,70.21z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M60.83,71.21h-1.17l-0.59-1.02l0.59-1.01h1.17l0.59,1.01L60.83,71.21z M60.24,70.21l0.03-0.02l-0.03-0.01 l-0.01,0.01L60.24,70.21z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 51.11,
    y: 39.89,
    className: "st1",
    width: 3.94,
    height: 1.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 58.59,
    y: 39.89,
    className: "st1",
    width: 3.94,
    height: 1.5
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.05,84.25h-1.46c-0.09,0-0.14-0.05-0.14-0.13v-0.71c0-0.08,0.05-0.13,0.14-0.13h4.14 c0.09,0,0.14,0.05,0.14,0.13v0.71c0,0.08-0.05,0.13-0.14,0.13h-1.46v3.15c0,0.08-0.05,0.13-0.14,0.13h-0.95 c-0.09,0-0.14-0.05-0.14-0.13V84.25z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.43,84.25v0.85c0,0.68-0.3,1.04-1.02,1.04h-0.02l1.17,1.27c0.05,0.05,0.02,0.13-0.05,0.13h-1.2 c-0.12,0-0.16-0.02-0.23-0.1l-1.05-1.24h-0.85v1.21c0,0.08-0.05,0.13-0.15,0.13h-0.94c-0.09,0-0.14-0.05-0.14-0.13v-3.99 c0-0.08,0.05-0.13,0.14-0.13h3.32C57.13,83.27,57.43,83.56,57.43,84.25z M54.18,85.21h1.61c0.35,0,0.41-0.05,0.41-0.35V84.6 c0-0.29-0.05-0.35-0.41-0.35h-1.61V85.21z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.93,87.4c0,0.08-0.05,0.13-0.15,0.13h-0.94c-0.09,0-0.14-0.05-0.14-0.13v-3.99c0-0.08,0.05-0.13,0.14-0.13 h0.94c0.09,0,0.15,0.05,0.15,0.13V87.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65.88,86.56c0,0.68-0.3,0.97-1.02,0.97h-2.6c-0.71,0-1.02-0.29-1.02-0.97v-2.31c0-0.68,0.32-0.97,1.02-0.97 h2.6c0.71,0,1.02,0.29,1.02,0.97V86.56z M64.65,84.64c0-0.33-0.07-0.39-0.47-0.39h-1.24c-0.4,0-0.47,0.06-0.47,0.39v1.52 c0,0.33,0.07,0.39,0.47,0.39h1.24c0.4,0,0.47-0.06,0.47-0.39V84.64z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrio);
export default __webpack_public_path__ + "static/media/trio.cad28e87824ec37e0729e937e1b1d889.svg";
export { ForwardRef as ReactComponent };